export enum PlanningDepartmentDocTypeId {
  SocialWelfareCertificate = 113,
  DismissalReasonExplanation = 8
}
